$(document).ready(function () {

  /**
   * Mobile menu flags.
   */
  $('.flags-wrapper .default-flag').on('click', function() {
    $(this).next('.other-flags').slideToggle();
    $(this).parent().parent().next('.mobile-search-form').toggleClass('fade');
  });

  /**
   * Mobile Product Mobile Info Icons.
   */
  var mobile_info_icons = $('#shopify-section-product-mobile-info-icons.shopify-section');
  $('#product-right .product-info-bottom').html(mobile_info_icons.html());
  mobile_info_icons.empty();

  /**
   * Extended Warranty.
   */
  if ($('.product-add-extended-warranty').length) {
    $('.extended-warranty-details').on('click', function() {
      $('.details-for-extend-warranty').slideToggle();
    });
  }

  /**
   * Product Options/Variants.
   */
  $('.add-to-cart-option', '.product-info').on('click', function(e) {
    e.preventDefault();
    let $product_options_wrapper = $(this).parent().prev('.product-options-wrapper');
    $product_options_wrapper.find('.selected-option').text($product_options_wrapper.find('.product-variant-input:checked').next('.product-variant-title').text());
    $product_options_wrapper.addClass('slide-up');
    $product_options_wrapper.prev('.product-options-wrapper-overlay').addClass('on');
    $('.page-wrap').addClass('product-options-open');
  });

  $('.product-variant-input', '.product-variants').on('click', function(e) {
    $(this).parent().parent().prev('.product-option-name').children('.selected-option').text($(this).next('.product-variant-title').text());
    // Update price.
    $(this).parent().parent().parent().parent().find('.product-info-price').attr('data-checked', 'false');
    $(this).parent().parent().parent().parent().find('.product-info-price[data-variant-id="' + $(this).val() + '"]').attr('data-checked', 'true');
  });

  $('.product-options-close', '.product-info').on('click', function(e) {
    $(this).parent().parent('.product-options-wrapper').removeClass('slide-up');
    $(this).parent().parent('.product-options-wrapper').prev('.product-options-wrapper-overlay').removeClass('on');
    $('.page-wrap').removeClass('product-options-open');
  });

  $(document).mouseup(function(e) {
    var container = $('.product-options-open .product-options-wrapper');
    // If the target of the click isn't the container nor a descendant of the container.
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.product-options-wrapper-overlay').removeClass('on');
      $('.product-options-wrapper').removeClass('slide-up');
      $('.page-wrap').removeClass('product-options-open');
    }
  });

  /**
   * Fixed Add to Cart.
   */
  if ($('.product-full').length) {

    var isMobile = window.matchMedia('only screen and (max-width: 479px)').matches;
    // Only for mobile.
    if (isMobile) {

      $('body').addClass('temp-fixed-cart-button');

      var addToCartWrapperPos = $('.add-to-cart-wrapper').offset().top + 51;

      $(window).on('scroll', function (e) {
        var scroll = $(window).scrollTop();
        if (scroll >= addToCartWrapperPos) {
          $('.product-add').addClass('with-padding');
          $('body').addClass('add-to-cart-fixed');
        } else {
          $('.product-add').removeClass('with-padding');
          $('body').removeClass('add-to-cart-fixed');
        }
      });

      $('#addToCart', '.add-to-cart-wrapper').on('click', function(e) {
        $('body').addClass('enable-recommended-add-on');

        $('.add-to-cart-wrapper').addClass('item-added');

        if ($('.product-recommended-add-on').length) {
          $('html, body').animate({
            scrollTop: ($('.product-recommended-add-on').offset().top - 202)
          }, 500);
        }
        else {
          $('html, body').animate({
            scrollTop: ($('.easytabs-accordion').offset().top)
          }, 500);
        }


        setTimeout(function() {
          window.SLIDECART_CLOSE();
          $('body').removeClass('enable-recommended-add-on');
        }, 700);

      });
    }
  }
});
